export default "__VITE_ASSET__Dh2ag2jT__"